

























import Vue from 'vue'
import AccountPaymentCard from '@/components/AccountPaymentCard.vue'
import { mapGetters } from 'vuex'
import subscriptionMixin from '@/mixins/subscription-mixin.js'
import PaymentHistory from '@/components/PaymentHistory.vue'
import SubscriptionInfo from '@/components/SubscriptionInfo.vue'
export default Vue.extend({
    mixins: [subscriptionMixin],
    components: { AccountPaymentCard, PaymentHistory, SubscriptionInfo },
    data() {
        return {
            loading: false
        }
    },
    computed: {
        ...mapGetters(['authIsAdmin', 'authIsSupport', 'tenant']),
        //  Return true if user has canceled
        canceled(): boolean {
            return (
                this.subscription &&
                (this.subscription.status === 'canceled' ||
                    this.subscription.cancel_at_period_end)
            )
        },
        operator(): boolean {
            //  Grab our current role
            const role = this.$store.getters.userRole(this.$store.getters.user)

            //  Check if this role is an operator
            return window.getProps(role, ['name']) === 'Operator'
        },
        pastDue(): boolean {
            //  Grab our subscription
            const sub = this.$store.getters.subscription

            //  If subscription isn't found, return false
            if (!sub) return false

            //  Grab the sub status
            const status = sub.status

            //  Return based on if status is past due or not
            return status === 'past_due'
        }
    },
    methods: {
        managePlan(): void {
            //  Navigate to the current subscription plan
            this.$router.push('/billing/manage')
        },
        async retryPayment(): Promise<void> {
            //  Start loading
            this.loading = true

            //  Attempt to retry payment
            const response = await this.$store.dispatch('stripePaymentRetry')

            //  Stop loading
            this.loading = false

            //  Create a message based on our status
            const msg = response ? 'Payment successfully retried.' : 'Payment failed.'

            //  We pop a notification bar depending on status
            this.$store.commit('appNotificationBarSet', {
                message: msg
            })
        }
    }
})
